import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPaymentDetail',
  setup(__props) {

const CreditCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/CreditCard.vue"))
const DebitCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/DebitCard.vue"))
const CodCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/CodCard.vue"))
const EmiCard = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/EmiCard.vue"))
const NetBanking = defineAsyncComponent(() => import("@/components/theme/ecommerce/payment/NetBanking.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "ECommerce",
      mains: "Payment Details",
      title: "Payment Details"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(CreditCard)),
        _createVNode(_unref(DebitCard)),
        _createVNode(_unref(CodCard)),
        _createVNode(_unref(EmiCard)),
        _createVNode(_unref(NetBanking))
      ])
    ])
  ], 64))
}
}

})